import "./assets/main.css"
import { createApp } from "vue"

import ApComponents from "@Mobile-Leaves-CORP/ap-components"
import SmartPageLib from "@atomicpixelsio/smart-page-library"
import { LandingRenderer } from "@atomicpixelsio/landing-renderer-v2"
import "@atomicpixelsio/smart-page-library/dist/style.css"
import "@atomicpixelsio/landing-renderer-v2/dist/landing-renderer-v2.css"
import "@Mobile-Leaves-CORP/ap-components/dist/style.css"
import "jodit/build/jodit.min.css"

import JoditVue from "jodit-vue"

import { abilitiesPlugin } from "@casl/vue"
import ability from "@/roles/rules"

import App from "./App.vue"
import router from "./router"
import i18n from "./locales"
import { pinia } from "@/pinia.js"

const app = createApp(App)

app.use(i18n)
app.use(ApComponents)
app.use(SmartPageLib)
app.use(JoditVue)
app.use(pinia)
app.use(router)
app.component("LandingRendererV2", LandingRenderer)
app.use(abilitiesPlugin, ability({ name: "Admin", permissions: [] }), {
  useGlobalProperties: true
})

app.mount("#app")
